const DEFAULT_DELAY = 1000;

export const fetchWithRetry = ({
  url,
  retries,
  delayForRetries = DEFAULT_DELAY,
}: {
  url: string;
  retries: number;
  delayForRetries?: number;
}): Promise<Response> =>
  fetch(url).catch(error => {
    if (retries > 0) {
      return wait(delayForRetries).then(() =>
        fetchWithRetry({ url, retries: retries - 1 }),
      );
    }
    throw new Error(error);
  });

const wait = (delay: number) =>
  new Promise(resolve => setTimeout(resolve, delay));
